import { render, staticRenderFns } from "./EditApartment.vue?vue&type=template&id=4fdde080&scoped=true"
import script from "./EditApartment.vue?vue&type=script&lang=js"
export * from "./EditApartment.vue?vue&type=script&lang=js"
import style0 from "./EditApartment.vue?vue&type=style&index=0&id=4fdde080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdde080",
  null
  
)

export default component.exports